import React from "react";
import Breadcrumbs from "../components/pageProps/Breadcrumbs";
import ShopSideNav from "../components/pageProps/shopPage/ShopSideNav";
import Product from "../components/home/Products/Product.js"; 
import {
    
     refrigerator1,
     refrigerator2,
     refrigerator3,
     refrigerator4,
     refrigerator5,
     refrigerator6,
     refrigerator7,
     refrigerator8,
     refrigerator9,
     refrigerator10,
     refrigerator11,
     refrigerator12,

} from "../assets/images/index"; 

const Refrigerator = () => {
  
  const products = [
     {
        _id:"100003",
        img:refrigerator1,
        productName:"DAWLANCE TWO DOOR INVERTER REFRIGERATOR Model 91999 GRAZE+ GEM BLACK",
        price:"149700",
        color:"DAWLANCE",
        badge:true,
        des:"The Dawlance 91999 Graze+Gem Black Refrigerator combines sophistication and functionality. Its spacious storage and energy-efficient performance make it a must-have for contemporary households."
      },
      {
        _id:"100004",
        img:refrigerator2,
        productName:"HAIER BEDROOM NON INVERTER REFRIGERATOR Model HR-66B",
        price:"35400",
        color:"HAIER",
        badge:true,
        des:" The Haier HR-66B is a compact, single-door refrigerator designed for bedroom use. With a capacity of 66 liters, it offers ample storage for your essentials. Its sleek black design and low-noise operation make it a perfect addition to any room."
      },
      {
        _id:"100005",
        img:refrigerator3,
        productName:"DAWLANCE NON INVERTER REFRIGERATOR Model 91999 CHROME HB",
        price:"123000",
        color:"DAWLANCE",
        badge:true,
        des:"The 91999 Chrome Hairline Black is a double door refrigerator from Dawlance. It’s designed with a sleek chrome hairline black finish and offers a spacious interior for all your food storage needs. It uses Vitamin Fresh Technology to preserve the maximum level of Vitamin A and C in fruits and vegetables, ensuring the health and immunity of your family."
      },
      {
        _id:"100006",
        img:refrigerator4,
        productName:"EASTCOOL BEDROOM NON INVERTER REFRIGERATOR Model TM542-18",
        price:"40200",
        color:"EASTCOOL",
        badge:true,
        des:" The Eastcool Refrigerator TM-542-08 is a compact, energy-efficient refrigerator with a unique lamp curved door design. It offers a 4 CUFT capacity and comes in various decorative colors."
      },
      {
        _id:"100007",
        img:refrigerator5,
        productName:"DAWLANCE BEDROOM SINGLE DOOR REFRIGERATOR Model 9106SD SILVER BLACK",
        price:"50100",
        color:"DAWLANCE",
        badge:true,
        des:"The Dawlance 9106 SD 6 Cu.ft silver black is a single door bedroom refrigerator that offers a compact yet spacious storage solution. It features Direct Cool technology and an inner freezer compartment for efficient cooling. The refrigerator is aesthetically appealing, complementing your bedroom’s ambiance."
      },
      {
        _id:"100008",
        img:refrigerator6,
        productName:"DAWLANCE VERTICAL FREEZER INVERTER Model VF 1035WB AVANTE+ GD CW",
        price:"113100",
        color:"DAWLANCE",
        badge:true,
        des:" The Dawlance Vertical Freezer Inverter 1035WB GD Avante+ is a space-saving freezer designed for efficient cooling and energy saving. It features Inverter Technology and operates on as low as 120V, providing reliable performance and long-lasting freshness."
      },
      {
        _id:"100009",
        img:refrigerator7,
        productName:"HAIER TWIN INVERTER + REFRIGERATOR Model HRF-538TIFRA",
        price:"146700",
        color:"HAIER",
        badge:true,
        des:"The Haier HRF-538TIFRA-Twin Inverter + is a cutting-edge refrigerator that combines superior cooling and energy efficiency. It’s equipped with Twin Inverter Technology and Twin Turbo Fans Technology for optimal performance, and A.SPE Sterilization Technology to keep your food fresh."
      },
      {
        _id:"1000010",
        img:refrigerator8,
        productName:"HAIER E-STAR REFRIGERATOR NON INVERTER Model HRF-186EBS",
        price:"65400",
        color:"HAIER",
        badge:true,
        des:" The HRF-186EBS is a single door refrigerator from the brand Haier. It’s designed for faster cooling and freezing with 1HIT technology. This refrigerator has a golden color and a total net capacity of 156 liters."
      },
      {
        _id:"1000011",
        img:refrigerator9,
        productName:"DAWLANCE TWO DOOR REFRIGERATOR INVERTER Model 91999 AVANTE+ CW",
        price:"147600",
        color:"DAWLANCE",
        badge:true,
        des:"The 91999 Avante+ Cloud White is a double door refrigerator from Dawlance, offering a sleek design and up to 10% more storage space. It’s equipped with advanced features for efficient cooling and energy saving."
      },
      {
        _id:"1000012",
        img:refrigerator10,
        productName:"HAIER E-STAR REFRIGERATOR NON INVERTER Model HRF-186 EBD",
        price:"64500",
        color:"HAIER",
        badge:true,
        des:" The HRF-186EBD is a single door refrigerator from the brand Haier. It’s designed for faster cooling and freezing with 1HIT technology. This refrigerator has a golden color and a total net capacity of 156 liters."
      },
      {
        _id:"1000013",
        img:refrigerator11,
        productName:"HAIER DIGITAL INVERTER REFRIGERATOR Model HRF-438IFRA",
        price:"132600",
        color:"HAIER",
        badge:true,
        des:"The Haier HRF-438IFRA is a digital inverter refrigerator that operates on a wide voltage range. It comes with a digital control system and four temperature sensors for optimal performance."
      },
      {
        _id:"1000014",
        img:refrigerator12,
        productName:"HAIER REFRIGERATOR TWIN INVERTER IOT Model HRF-538TIFGU1",
        price:"153000",
        color:"HAIER",
        badge:true,
        des:" The Twin Inverter IOT HRF-538TIFGU1 is a high-capacity refrigerator from Haier, launched in 2024. It features IoT technology, twin turbo fans, and A.SPE sterilization technology."
      },
      {
        _id:"100003",
        img:refrigerator1,
        productName:"DAWLANCE TWO DOOR INVERTER REFRIGERATOR Model 91999 GRAZE+ GEM BLACK",
        price:"149700",
        color:"DAWLANCE",
        badge:true,
        des:"The Dawlance 91999 Graze+Gem Black Refrigerator combines sophistication and functionality. Its spacious storage and energy-efficient performance make it a must-have for contemporary households."
      },
      {
        _id:"100004",
        img:refrigerator2,
        productName:"HAIER BEDROOM NON INVERTER REFRIGERATOR Model HR-66B",
        price:"35400",
        color:"HAIER",
        badge:true,
        des:" The Haier HR-66B is a compact, single-door refrigerator designed for bedroom use. With a capacity of 66 liters, it offers ample storage for your essentials. Its sleek black design and low-noise operation make it a perfect addition to any room."
      },
      {
        _id:"100005",
        img:refrigerator3,
        productName:"DAWLANCE NON INVERTER REFRIGERATOR Model 91999 CHROME HB",
        price:"123000",
        color:"DAWLANCE",
        badge:true,
        des:"The 91999 Chrome Hairline Black is a double door refrigerator from Dawlance. It’s designed with a sleek chrome hairline black finish and offers a spacious interior for all your food storage needs. It uses Vitamin Fresh Technology to preserve the maximum level of Vitamin A and C in fruits and vegetables, ensuring the health and immunity of your family."
      },
      {
        _id:"100006",
        img:refrigerator4,
        productName:"EASTCOOL BEDROOM NON INVERTER REFRIGERATOR Model TM542-18",
        price:"40200",
        color:"EASTCOOL",
        badge:true,
        des:" The Eastcool Refrigerator TM-542-08 is a compact, energy-efficient refrigerator with a unique lamp curved door design. It offers a 4 CUFT capacity and comes in various decorative colors."
      },
      
    
  ];

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Refrigerator" />
      
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
         
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
            {products.map((product) => (
              <Product
                key={product._id}
                _id={product._id}
                img={product.img}
                productName={product.productName}
                price={product.price}
                color={product.color}
                badge={product.badge}
                des={product.des}
              />
            ))}
          </div>
         
        </div>
      </div>
      
    </div>
  );
};

export default Refrigerator;
